import ltiApi from '@/services/plataforma/lti';

export default {
  async getToolListByProviderId({ commit }, { page, limit, sortBy, order, providerId, filter }) {
    return ltiApi.getToolListByProviderId(page, limit, sortBy, order, providerId, filter)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  async getAllByRoleAlias({ commit }, rolesAlias) {
    return ltiApi.getAllByRoleAlias(rolesAlias)
      .then(response => {
        return Promise.resolve(response.data);
      })
      .catch(e => Promise.reject(e.response.data.error));
  },
  async createLtiProviderTool({ commit }, ltiProvider) {
    return ltiApi.createLtiProviderTool(ltiProvider)
      .then(response => {
        return Promise.resolve(response.data);
      })
      .catch(e => Promise.reject(e.response.data.error));
  },
  async editLtiProviderTool({ commit }, ltiProvider) {
    return ltiApi.editLtiProviderTool(ltiProvider)
      .then(response => {
        return Promise.resolve(response.data);
      })
      .catch(e => Promise.reject(e.response.data.error));
  },
  async deleteLtiProviderTool(_, id) {
    return ltiApi.deleteLtiProviderTool(id)
      .then(() => Promise.resolve())
      .catch(e => Promise.reject(e.response.data.error));
  }
};
